import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { X, Headphones } from "lucide-react";
import faqData from "../data/faqData.json";
import "./FAQWidget.css";

const FAQWidget = () => {
  
  const [isOpen, setIsOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  
  
  if (location.pathname === "/" || location.pathname === "/auth") return null;


  const handleContactRedirect = () => {
    setIsOpen(false);
    navigate("/contact");
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-widget-wrapper">
      {/* FAQ Window */}
      <div className={`faq-window ${isOpen ? "open" : ""}`}>
        {/* Header */}
        <div className="faq-header">
          <div className="header-text">
            <h3>FAQs</h3>
            <span className="online-status">
              <span className="dot">●</span> Support
            </span>
          </div>
          <button className="close-btn" onClick={() => setIsOpen(false)}>
            <X size={22} />
          </button>
        </div>

        {/* Body */}
        <div className="faq-body">
          <div className="faq-list">
            {faqData?.faqs?.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? "active" : ""}`}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  type="button"
                >
                  {faq.question}
                  <span className="faq-icon">
                    {openIndex === index ? "−" : "+"}
                  </span>
                </button>

                <div className="faq-answer-wrapper">
                  <div className="faq-answer">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="faq-footer">
            <p>Still need help?</p>
            <button className="contact-btn" onClick={handleContactRedirect}>
              <Headphones size={16} /> Talk to our team
            </button>
          </div>
        </div>
      </div>

      {/* Trigger Button */}
      <button
        className="faq-trigger-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close FAQ" : "Open FAQ"}
      >
        {isOpen ? <X size={28} /> : "FAQ"}
      </button>
    </div>
  );
};

export default FAQWidget;